import React from 'react'
import {Link} from 'react-router-dom'
import Layout from '../layouts/centered'
import CenteredForm from '../layouts/centered-form'
import ForgotPassword from '../components/sample-forms/forgot-password'

const Index = () => {
  return (
    <Layout>
      <CenteredForm
        title="Lupa Kata Sandi"
        subtitle="Silakan masukkan alamat email Anda untuk memulihkan kata sandi Anda. Sistem akan mengirimkan email kepada Anda dengan instruksi untuk mereset kata sandi dan berlaku selama 15 menit saja.">
        <ForgotPassword message="Anda akan menerima email untuk memulihkan kata sandi Anda. Silakan periksa folder Inbox/Spam." />
        <div className="w-full mt-2">
          <span>
            <Link to="/login" className="link">
              Kembali ke login
            </Link>
          </span>
        </div>
      </CenteredForm>
    </Layout>
  )
}

export default Index
